import * as actionsType from './actionsType';
import axiosInstance from '../../axiosInstance';

export const mailSendStart = () => {
    return {
        type: actionsType.MAIL_SEND_START,
    };
};

export const mailSendSuccess = () => {
    return {
        type: actionsType.MAIL_SEND_SUCCESS,
    };
};

export const mailSendFail = (error) => {
    return {
        type: actionsType.MAIL_SEND_FAIL,
        error: error,
    };
};

export const sendMail = (data) => {
    return distpatch => {
        distpatch(mailSendStart());
        axiosInstance.post(
            '/send-mail.php',
            data
        )
            .then(response => {
                const responseData = response.data;
                if (responseData.success) {
                    distpatch(mailSendSuccess());
                } else {
                    let errors = ['Server error'];
                    if (responseData.errors) {
                        errors = responseData.errors;
                    }
                    distpatch(mailSendFail(errors));
                }
            })
            .catch(error => {
                distpatch(mailSendFail([error.toString()]));
            });
    }
};